import { render, staticRenderFns } from "./CmgRewardsExchange.vue?vue&type=template&id=f225f59e&scoped=true&lang=pug&"
import script from "./cmg-rewards-exchange.ts?vue&type=script&lang=ts&"
export * from "./cmg-rewards-exchange.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRewardsExchange.vue?vue&type=style&index=0&id=f225f59e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f225f59e",
  null
  
)

export default component.exports